import { type Product } from '../models'

export function isCustom(product: Product): boolean {
  return !product.unit
}
